import { BrandLogo } from "@/components/BrandLogo";

interface BrandLoadingSplashProps {
  text?: string;
  fullScreen?: boolean;
  className?: string;
}

export const BrandLoadingSplash = ({ 
  text, 
  fullScreen = true, 
  className = "" 
}: BrandLoadingSplashProps) => {
  return (
    <div className={`flex flex-col items-center justify-center ${fullScreen ? 'min-h-screen' : 'min-h-[400px]'} bg-background ${className}`}>
      <BrandLogo variant="icon" className="h-16 w-16 animate-brand-glow" />
      {text && (
        <p className="mt-4 text-sm text-muted-foreground animate-pulse">{text}</p>
      )}
    </div>
  );
};
